export async function svgStringToHTML(path: string) {
  const response = await fetch(path);
  const svgContent = await response.text();

  const wrapperElement = document.createElement('div');

  wrapperElement.innerHTML = svgContent as string;

  const svgElement = wrapperElement.querySelector('svg');

  svgElement?.removeAttribute('width');
  svgElement?.removeAttribute('height');

  return svgElement;
}
